
import { useEffect, useState } from 'react';

const axios = require('axios');

export const AxiosAuthGet = (url = '', token = '') => {
    const [apiResponse, setApiResponse] = useState(null);
    useEffect(() => {
        let mounted = true;
        axios.get(
            url,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            })
            .then(function (response) {
                if (mounted) {
                    // handle success
                    setApiResponse(response);
                }
            })
            .catch(function (error) {
                if (mounted) {
                    if(error.response && error.response.status == 401){
                        window.location = "#/401";
                    }else if(error.response && error.response.status == 404){
                        window.location = "#/404";
                    }else if(error.response && error.response.status >= 500){
                        window.location = "#/500";
                    }
                    // handle error
                    setApiResponse(error);
                }
            })
            .then(function () {
                // always executed
            });
        return function cleanup() {
            mounted = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return apiResponse;
}

export async function axiosGet(url = '', token = '') {
    let answer = null;
    // Make a request for a user with a given ID
    await axios.get(
        url,
        {
            headers: {
                "Authorization": `Bearer ${token}`,
                'content-type': 'application/x-www-form-urlencoded'
            },
        })
        .then(function (response) {
            // handle success
            answer = response;
        })
        .catch(function (error) {
            if(error.response && error.response.status == 401){
                window.location = "#/401";
            }else if(error.response && error.response.status == 404){
                window.location = "#/404";
            }else if(error.response && error.response.status >= 500){
                window.location = "#/500";
            }
            // handle error
            answer = error;
        })
        .then(function () {
            // always executed
        });
    return answer;
}

export async function axiosAuthGetNoState(url = '', token = '') {
    let answer = null;
    // Make a request for a user with a given ID
    await axios.get(
        url,
        {
            headers: {
                "Authorization": `Bearer ${token}`,
                'content-type': 'application/x-www-form-urlencoded'
            },
        })
        .then(function (response) {
            // handle success
            answer = response;
        })
        .catch(function (error) {
            if(error.response && error.response.status == 401){
                window.location = "#/401";
            }else if(error.response && error.response.status == 404){
                window.location = "#/404";
            }else if(error.response && error.response.status >= 500){
                window.location = "#/500";
            }
            // handle error
            answer = error;
        })
        .then(function () {
            // always executed
        });
    return answer;
}

export async function axiosAuthGetNoStateForDownload(url = '', token = '', fileName) {
    let answer = null;
    // Make a request for a user with a given ID
    await axios.get(
        url,
        {
            headers: {
                "Authorization": `Bearer ${token}`
            },
            responseType: 'blob'
        })
        .then(function (response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); //or any other extension
            document.body.appendChild(link);
            link.click();
        })
        .catch(function (error) {
            if(error.response && error.response.status == 401){
                window.location = "#/401";
            }else if(error.response && error.response.status == 404){
                window.location = "#/404";
            }else if(error.response && error.response.status >= 500){
                window.location = "#/500";
            }
            // handle error
            answer = error;
        });
    return answer;
}

export async function axiosAuthPost(url = '', params = {}, token = '', convertir = true) {
    let answer = null;
    let bodyFormData = new FormData();
    Object.keys(params).forEach(key =>
        bodyFormData.append(key, (convertir === true) ? JSON.stringify(params[key]) : params[key])
    );
    // Make a request for a user with a given ID
    await axios.post(
        url,
        bodyFormData,
        {
            headers: {
                "Authorization": `Bearer ${token}`,
                'content-type': 'application/x-www-form-urlencoded'
            },
        })
        .then(function (response) {
            // handle success
            answer = response;
        })
        .catch(function (error) {
            if(error.response && error.response.status == 401){
                window.location = "#/401";
            }else if(error.response && error.response.status == 404){
                window.location = "#/404";
            }else if(error.response && error.response.status >= 500){
                window.location = "#/500";
            }
            // handle error
            answer = error;
        })
        .then(function () {
            // always executed
        });
    return answer;
}

export async function axiosAuthPostNoState(url = '', params = {}, token = '') {
    let bodyFormData = new FormData();

    Object.keys(params).forEach(key =>
        bodyFormData.append(key, params[key])
    );
    
    let answer = null;
    // Make a request for a user with a given ID
    await axios.post(
        url,
        bodyFormData,
        {
            headers: {
                "Authorization": `Bearer ${token}`,
                'content-type': 'application/x-www-form-urlencoded'
            },
        })
        .then(function (response) {
            // handle success
            answer = response;
        })
        .catch(function (error) {
            if(error.response && error.response.status == 401){
                window.location = "#/401";
            }else if(error.response && error.response.status == 404){
                window.location = "#/404";
            }else if(error.response && error.response.status >= 500){
                window.location = "#/500";
            }
            // handle error
            answer = error;
        })
        .then(function () {
            // always executed
        });
    return answer;
}

export async function axiosAuthPostWithFiles(url = '', params = {}, token = '') {
    let bodyFormData = new FormData();

    Object.keys(params).forEach(key =>
        bodyFormData.append(key, params[key])
    );

    let answer = null;
    // Make a request for a user with a given ID
    await axios.post(
        url,
        bodyFormData,
        {
            headers: {
                "Authorization": `Bearer ${token}`,
                'content-type': `multipart/form-data; boundary=${bodyFormData._boundary}`,
            },
        })
        .then(function (response) {
            // handle success
            answer = response;
        })
        .catch(function (error) {
            if(error.response && error.response.status == 401){
                window.location = "#/401";
            }else if(error.response && error.response.status == 404){
                window.location = "#/404";
            }else if(error.response && error.response.status >= 500){
                window.location = "#/500";
            }
            // handle error
            answer = error;
        })
        .then(function () {
            // always executed
        });
    return answer;
}

function buildFormData(formData, data, parentKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof Blob)) {
      Object.keys(data).forEach(key => {
        buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
      });
    } else {
      const value = data == null ? '' : data;
  
      formData.append(parentKey, value);
    }
  }